<template>
  <div class="buildings-overview">
    <div class="row mt-4">
      <div class="col">
        <h4>Building Lookup</h4>
        <building-lookup></building-lookup>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <h4>{{ userStore.user.firstName }}'s Recent Buildings</h4>
        <building-list
          :buildings="currentUserBuildings"
          :min-cols="true"
        ></building-list>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <h4>Other Recent Buildings</h4>
        <div class="building-list">
          <building-list
            :buildings="recentBuildings"
            :min-cols="true"
          ></building-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import BuildingList from '@/components/BuildingList'
import BuildingLookup from '@/components/BuildingLookup'
import { userStore } from '@/stores/userStore'

export default {
  name: 'BuildingsOverviewPage',
  components: { BuildingList, BuildingLookup },
  inject: {
    userStore,
  },
  data: function() {
    return {
      currentUserBuildings: [],
      recentBuildings: [],
    }
  },
  methods: {
    getUserRecentBuildings() {
      return axios
        .get('/services/buildings/currentUser')
        .then(response => {
          this.currentUserBuildings = response.data.buildings
        })
        .catch(err => {
          console.log('err', err)
        })
    },
    getRecentBuildings() {
      return axios
        .get('/services/buildings/recent')
        .then(response => {
          this.recentBuildings = response.data.buildings
        })
        .catch(err => {
          console.log('err', err)
        })
    },
  },
  mounted() {
    if (
      userStore.user.type === 'SALES' ||
      userStore.user.type === 'ADMIN' ||
      userStore.user.type === 'MANUFACTURING' ||
      userStore.user.type === 'MANAGER'
    ) {
      this.getUserRecentBuildings()
      this.getRecentBuildings()
    }
  },
}
</script>

<style lang="scss" scoped>
.buildings-overview {
  // Inherits styles from parent
}
</style>
